import { FC, useCallback } from "react";
import { observer } from "mobx-react-lite";

import { VirtualizedItemList } from "@/components/item-list";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import { AudioRecordingsListPageListEmpty } from "./audio-recordings-list-page-empty";

type Props = Record<string, never>;

export const AudioRecordingsListPageList: FC<Props> = observer(() => {
  const page = useTabPageStore("audioRecordingsListPage");

  const handleEndReached = useCallback(() => {
    if (!page.canLoadMore) {
      return;
    }
    page.increaseLimit();
  }, [page]);

  if (page.hasNoItems) {
    return <AudioRecordingsListPageListEmpty />;
  }

  if (page.isLoading) {
    return null;
  }

  return (
    <VirtualizedItemList
      rows={page.itemRows}
      listState={page.listState}
      scrollTop={page.scrollTop}
      setScrollTop={page.setScrollTop}
      endReached={handleEndReached}
    />
  );
});
